var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSilentBellIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 88.09 99.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m42.1,99.95h0c5.65,0,10.23-4.6,10.23-10.26h-20.47c0,5.67,4.58,10.26,10.23,10.26Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m72.42,41.73c0-14.31-9.73-26.3-22.84-29.54v-5.35c0-3.78-3.02-6.84-6.74-6.84h-2.05c-3.72,0-6.74,3.06-6.74,6.84v5.35c-2.54.63-4.95,1.6-7.19,2.84l45.55,47.06v-20.35Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m6.92,4.73l.37-.36-.06-.07L0,11.35l15.03,15.53c-2.43,4.39-3.82,9.46-3.82,14.86v27.95l-9.9,9.36v5.22h69.28l10.65,11,6.85-6.68L6.92,4.73Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilentBellIcon);
export default __webpack_public_path__ + "static/media/SilentBellIcon.d6ebeebf38d5b361b0d4c8af24e2caf9.svg";
export { ForwardRef as ReactComponent };